<script lang="ts">
    const NEW_URL = "https://what-to-listen.palpfiction.dev";

    // Only show this on the old Deno Deploy host. The same code runs on the
    // new domain, where the notice should never appear.
    const isLegacyHost = /(^|\.)deno\.(net|dev)$/.test(
        window.location.hostname
    );
</script>

{#if isLegacyHost}
    <aside aria-label="migration notice">
        <p>
            this app is moving to
            <a href={NEW_URL}>what-to-listen.palpfiction.dev</a>.
            this page will be retired in early december, so please update your
            bookmarks.
        </p>
        <a class="redirect" href={NEW_URL}>take me to the new home →</a>
    </aside>
{/if}

<style>
    aside {
        box-sizing: border-box;
        max-width: 500px;
        margin: 1em auto 0;
        padding: 1em;
        border: 2px solid var(--primary);
        border-radius: var(--border-radius);
        color: #555;
        font-size: 0.9em;
    }

    p {
        margin: 0 0 1em;
    }

    .redirect {
        display: inline-block;
        padding: 0.5em 1em;
        background-color: var(--primary);
        color: white;
        border-radius: var(--border-radius);
        transition: 0.1s;
    }

    .redirect:hover {
        text-decoration: none;
        transform: translate(-4px, -4px);
        box-shadow: 4px 4px black;
    }

    @media only screen and (max-width: 768px) {
        aside {
            margin: 0.5em;
            font-size: small;
        }
    }
</style>
